import React from 'react';
import { Routes, Route } from "react-router-dom";
import Login from "./Pages/Login";
import HomePage from "./Pages/HomePage";
import ProductDetails from "./Pages/ProductDetails";
import Pay from "./Pages/Pay";
import CartPage from "./Pages/CartPage";
import OrdersPage from "./Pages/OrderPage";
import UserPage from "./Pages/UserPage";
import SellPage from "./Pages/SellPage";
import "./App.css";

function App() {
  return (
    <Routes>
      <Route path="/" element={<Login />} />
      <Route path="/login" element={<Login />} />
      <Route path="/homepage" element={<HomePage />} />
      <Route path="/product/:id" element={<ProductDetails />} />
      <Route path="/pay/:id" element={<Pay />} />
      <Route path="/cart" element={<CartPage />} />
      <Route path="/orders" element={<OrdersPage />} />
      <Route path="/user" element={<UserPage />} />
      <Route path="/sell" element={<SellPage />} />
    </Routes>
  );
}

export default App;